if( !jQuery.trim( $('.menu-subcollection').html() ).length ) {
  jQuery('.content-subcollection .title-parent-sub').addClass('no-subcollection');
}else {
  jQuery('.content-subcollection .title-parent-sub').removeClass('no-subcollection');
}
// Zooomy heart positioning removed — our heart is now CSS-positioned
// absolutely on .grid-item.grid-product. See `.hc-wishlist-heart--card` in
// custom-styles.css.liquid.

var atrvideoid = $('.lite-youtube').attr("videoid");
$( ".lite-youtube" ).replaceWith( "<lite-youtube videoid='"+ atrvideoid +"'></lite-youtube>" );
/*chatbecon*/
document.addEventListener("DOMContentLoaded", () => {
  const beacon = document.querySelector("#beacon");
  if (!beacon) return;
  // Skip listener wiring when the beacon is hidden (mobile non-help pages).
  if (window.getComputedStyle(beacon).display === "none") return;

  beacon.addEventListener("touchstart", (e) => {
    loadBeacon();
  },{ passive: true });

  beacon.addEventListener("click", (e) => {
    beacon.classList.add("bea-loading");
    loadBeacon();
    window.Beacon("open");
    beacon.style.zIndex = 1000;
   });

  function loadBeacon() {
    
    if (typeof window.Beacon == "undefined") {
      
      var script = document.createElement("script");
      script.id = "beacon";
      script.text = `!function(e,t,n){function a(){var e=t.getElementsByTagName("script")[0],n=t.createElement("script");n.type="text/javascript",n.async=!0,n.src="https://beacon-v2.helpscout.net",e.parentNode.insertBefore(n,e)}if(e.Beacon=n=function(t,n,a){e.Beacon.readyQueue.push({method:t,options:n,data:a})},n.readyQueue=[],"complete"===t.readyState)return a();e.attachEvent?e.attachEvent("onload",a):e.addEventListener("load",a,!1)}(window,document,window.Beacon||function(){});`;
      document.head.appendChild(script);
	  window.Beacon("init", "cae1c2f2-5566-4b84-a98f-f8ca2bd2e5a3");
	  
    }
    
  }

});

/*Endchat becon*/

/*Remove option Filter collection page*/
$('.collection-filter__sort #SortBy option').each(function() {
  if ( $(this).val() == 'created-descending'|| $(this).val() == 'created-ascending'  || $(this).val() == 'price-descending' || $(this).val() == 'price-ascending' || $(this).val() == 'best-selling') {
        $(this).remove();
    }
  if($(this).val() == 'manual') {
     $(this).text('Popularity');
  }
});
/*End Remove option Filter collection page*/

if($('.carousel-custom').length) {
  $('.carousel-custom .arrow').click(function() {
      var slideContainerEl = $(this).parents('.carousel-custom').find('.slide-container');
      var slideEl = $(this).parents('.carousel-custom').find('.slide');
      var slideWidth = slideEl.width();
      $(window).on("resize", function(){
        slideWidth = slideEl.width();
      });
      var maxScrollLeft = slideContainerEl[0].scrollWidth - slideContainerEl.width();
      var position = 0;
      var width = 0;
      var arg = $(this).data("arrow");
      if (arg === "forward") {
          width = slideContainerEl.scrollLeft() + parseInt(slideWidth) ;
          position = width <= maxScrollLeft ? width : 0;
      } else if (arg === "backward") {
          width = slideContainerEl.scrollLeft() - parseInt(slideWidth);
          position = width >= 0 ? width : maxScrollLeft;
      }
      slideContainerEl.scrollLeft(position);
   });
  $(".slide-indicator:first-child").addClass('active');
  $(".carousel-custom .slide-indicator").click(function() { 
      var slideIndex = $(this).data("slideindex");
      var slideContainerEl = $(this).parents('.carousel-custom').find('.slide-container');
      var slideEl = jQuery(this).parents('.carousel-custom').find('.slide');
      var slideWidth = slideEl.width();
      $(window).on("resize", function(){
        slideWidth = slideEl.width();
      });
      var position = slideIndex * (slideWidth);
      slideContainerEl.scrollLeft(position);
  });
  var down =0;
  var up =0;
  $(".move-slide").mousedown(function(event){
      down = parseInt(event.pageX);
  });
  $(".slide-container").on("scroll",function(){ 
      var position = $(this).scrollLeft() / $(this).width();
      $(".slide-indicator").removeClass('active');
      $('*[data-slideindex="'+ position.toFixed() +'"]').addClass("active")
  });  
  $(".move-slide").mouseup(function(event) {
      var slideContainerEl = jQuery(this).parents('.carousel-custom').find('.slide-container');
      var slideEl = jQuery(this).parents('.carousel-custom').find('.slide');
      var slideWidth = slideEl.width();
      jQuery(window).on("resize", function(){
        slideWidth = slideEl.width();
      });
      var maxScrollLeft = slideContainerEl[0].scrollWidth - slideContainerEl.width();
      var position = 0;
      var width = 0;
      up = parseInt(event.pageX);
      if(down > up) {
         width = slideContainerEl.scrollLeft() + parseInt(slideWidth);
         position = width <= maxScrollLeft ? width : 0;
         slideContainerEl.scrollLeft(position);
      }
      if(down < up) {
         width = slideContainerEl.scrollLeft() - parseInt(slideWidth);
         position = width >= 0 ? width : maxScrollLeft;
         slideContainerEl.scrollLeft(position);
      }
  });
}
/*Delivery Instructions*/
(function() {
  function initDeliveryInstructions() {
    var toggle = document.getElementById('DeliveryToggleDrawer');
    var fields = document.getElementById('DeliveryFieldsDrawer');
    var select = document.getElementById('CartDeliveryPreference');
    var details = document.getElementById('CartDeliveryDetails');
    if (!toggle || !fields || !select || !details) return;

    // Toggle open/close
    toggle.addEventListener('click', function(e) {
      e.preventDefault();
      toggle.classList.toggle('is-active');
      fields.classList.toggle('hide');
    });

    // Auto-open if values already saved
    if (select.value || details.value) {
      toggle.classList.add('is-active');
      fields.classList.remove('hide');
    }

    // Save preference on change
    select.addEventListener('change', function() {
      theme.cart.updateAttribute('Delivery Preference', this.value);
      if (!this.value) {
        details.value = '';
        theme.cart.updateAttribute('Delivery Details', '');
      }
    });

    // Save details on change (debounced)
    var detailsTimer;
    details.addEventListener('input', function() {
      clearTimeout(detailsTimer);
      var val = this.value;
      detailsTimer = setTimeout(function() {
        theme.cart.updateAttribute('Delivery Details', val);
      }, 500);
    });
  }

  document.addEventListener('DOMContentLoaded', initDeliveryInstructions);
  // Re-init when cart drawer opens (in case of dynamic content)
  window.addEventListener('CartDrawer:open', initDeliveryInstructions);
})();

/*Newletter*/
 $(document).ready(function() {
    if (window.location.href.indexOf("prospect%2Cnewsletter&form_type=customer") > -1) {
      $(".note--success").addClass("old-subscriber-true");
    }
    else {
    $(".note--success").removeClass("old-subscriber-true");
    }
  });
jQuery(function() {
          var rprice = $('.product-block--price .product__price').html();
          $('.atc-price').html(rprice);
          $('.variant-input').on('click', function(){
            setTimeout(function(){
              var rprice = $('.product-block--price .product__price').html();
              var sprice = $('.product-block--price .product__price').html();
             var priceNumR = parseFloat(rprice.substring(1));
              var priceNumS = parseFloat(sprice.substring(1));

              if(priceNumR > priceNumS){
                $('.atc-price').html(sprice);
              }else{
                $('.atc-price').html(rprice);
              }

            }, 1);
          });
        });

/*============================================================================
  Quantity Limits (per-variant)
  - Reads max_quantity from variant metafields
  - Prevents adding over-limit items on product page
  - Caps quantity controls in cart page & drawer
  - Updates limit display when variant changes
==============================================================================*/
(function() {
  'use strict';

  // Cached cart state — kept in sync via events
  var cachedCart = null;

  function fetchCart() {
    return fetch('/cart.js?t=' + Date.now(), {
      credentials: 'same-origin',
      method: 'GET'
    }).then(function(r) { return r.json(); })
      .then(function(cart) { cachedCart = cart; return cart; });
  }

  // Fetch cart on load (for product page add-to-cart checks)
  fetchCart();

  // Keep cache fresh when cart updates
  document.addEventListener('cart:updated', function(evt) {
    if (evt.detail && evt.detail.cart) {
      cachedCart = evt.detail.cart;
    } else {
      fetchCart();
    }
  });
  document.addEventListener('ajaxProduct:added', function() {
    fetchCart();
  });

  // --- Read variant max qty map from JSON script tag ---
  function getVariantMaxQtyMap(form) {
    var script = form.querySelector('[data-variant-max-qty]');
    if (!script) return {};
    try { return JSON.parse(script.textContent); } catch(e) { return {}; }
  }

  function getMaxQtyForVariant(form, variantId) {
    var map = getVariantMaxQtyMap(form);
    return map[String(variantId)] || null;
  }

  // --- Error display ---
  function showLimitError(target, message) {
    var existing = target.querySelector('.qty-limit-error');
    if (existing) existing.remove();

    var el = document.createElement('div');
    el.className = 'qty-limit-error';
    el.textContent = message;
    target.appendChild(el);

    setTimeout(function() { el.remove(); }, 4000);
  }

  // --- Product page: update limit notice & max attr when variant changes ---
  function updateProductPageLimit(form, variantId) {
    var maxQty = getMaxQtyForVariant(form, variantId);

    // The quantity input may be outside the form (linked via form="" attribute)
    // so search the nearest product section container, not just inside the form
    var section = form.closest('[data-section-id], .shopify-section, .product-section') || form.parentNode;

    // Update quantity input max attribute
    var qtyInput = section.querySelector('.js-qty__num[name="quantity"]')
                || form.querySelector('.js-qty__num[name="quantity"]');
    if (qtyInput) {
      if (maxQty) {
        qtyInput.setAttribute('max', maxQty);
        // Clamp current value if over new limit
        var current = parseInt(qtyInput.value) || 1;
        if (current > maxQty) qtyInput.value = maxQty;
      } else {
        qtyInput.removeAttribute('max');
      }
    }

    // Update wrapper data attribute
    var wrapper = section.querySelector('.js-qty__wrapper')
              || form.querySelector('.js-qty__wrapper');
    if (wrapper) {
      if (maxQty) {
        wrapper.setAttribute('data-max-qty', maxQty);
      } else {
        wrapper.removeAttribute('data-max-qty');
      }
    }

    // Update limit notice text
    var notice = section.querySelector('[data-qty-limit-notice]')
             || form.querySelector('[data-qty-limit-notice]');
    if (notice) {
      if (maxQty) {
        notice.textContent = 'Limit of ' + maxQty + ' per customer.';
        notice.classList.remove('qty-limit-notice--reserved');
      } else {
        notice.innerHTML = '&nbsp;';
        notice.classList.add('qty-limit-notice--reserved');
      }
    }

    // Clear any existing error when switching variants
    var existingErrors = section.querySelectorAll('.qty-limit-error');
    existingErrors.forEach(function(el) { el.remove(); });
  }

  // Listen for variant changes (Expanse theme fires variant:change on document)
  document.addEventListener('variant:change', function(evt) {
    if (!evt.detail || !evt.detail.variant) return;
    var variant = evt.detail.variant;
    var form = document.querySelector('.product-single__form');
    if (form) updateProductPageLimit(form, variant.id);
  });

  // --- Product page: intercept add-to-cart ---
  document.addEventListener('submit', function(evt) {
    var form = evt.target;
    if (!form.classList.contains('product-single__form')) return;

    // Get the variant being added
    var variantSelect = form.querySelector('[name="id"]');
    var variantId = variantSelect ? variantSelect.value : null;
    if (!variantId) return;

    var maxQty = getMaxQtyForVariant(form, variantId);
    if (!maxQty) return; // No limit for this variant

    // Quantity input may be outside form (linked via form="" attribute)
    var qtyEl = form.querySelector('[name="quantity"]');
    if (!qtyEl) {
      var section = form.closest('[data-section-id], .shopify-section, .product-section') || form.parentNode;
      qtyEl = section.querySelector('.js-qty__num[name="quantity"]');
    }
    var requestedQty = qtyEl ? (parseInt(qtyEl.value) || 1) : 1;

    // Check how many of this variant are already in cart
    var inCart = 0;
    if (cachedCart && cachedCart.items) {
      for (var i = 0; i < cachedCart.items.length; i++) {
        if (String(cachedCart.items[i].variant_id) === String(variantId)) {
          inCart = cachedCart.items[i].quantity;
          break;
        }
      }
    }

    if (inCart + requestedQty > maxQty) {
      evt.preventDefault();
      evt.stopImmediatePropagation();

      var remaining = maxQty - inCart;
      var msg;
      if (remaining <= 0) {
        msg = 'You already have the maximum of ' + maxQty + ' in your cart.';
      } else {
        msg = 'You can only add ' + remaining + ' more (limit of ' + maxQty + ' per customer).';
      }

      // Remove loading state from button
      var btn = form.querySelector('[data-add-to-cart]');
      if (btn) btn.classList.remove('btn--loading');

      var section = form.closest('[data-section-id], .shopify-section, .product-section') || form.parentNode;
      var qtyBlock = form.querySelector('.product__quantity') || section.querySelector('.product__quantity') || form;
      showLimitError(qtyBlock, msg);
      return false;
    }
  }, true); // capture phase — runs before ProductForm handler

  // --- Cart page & drawer: cap the + button ---
  document.addEventListener('click', function(evt) {
    var plusBtn = evt.target.closest('.js-qty__adjust--plus');
    if (!plusBtn) return;

    var wrapper = plusBtn.closest('.js-qty__wrapper');
    if (!wrapper) return;

    var input = wrapper.querySelector('.js-qty__num');
    if (!input) return;

    var maxQty = parseInt(input.getAttribute('max'));
    if (!maxQty || isNaN(maxQty)) return;

    var currentQty = parseInt(input.value) || 1;

    if (currentQty >= maxQty) {
      evt.stopImmediatePropagation();
      evt.preventDefault();
      showLimitError(wrapper.closest('.cart__item') || wrapper.parentNode, 'Maximum of ' + maxQty + ' allowed.');
    }
  }, true); // capture phase

  // --- Cart page & drawer: clamp manual input ---
  document.addEventListener('change', function(evt) {
    var input = evt.target;
    if (!input.classList.contains('js-qty__num')) return;

    var maxQty = parseInt(input.getAttribute('max'));
    if (!maxQty || isNaN(maxQty)) return;

    var val = parseInt(input.value) || 1;
    if (val > maxQty) {
      input.value = maxQty;
      showLimitError(input.closest('.cart__item') || input.parentNode, 'Maximum of ' + maxQty + ' allowed.');
    }
  }, true); // capture phase

  // --- Collection page: intercept quick-add buttons with limits ---
  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest('.js-quick-add-btn[data-max-qty]');
    if (!btn) return;

    var maxQty = parseInt(btn.getAttribute('data-max-qty'));
    if (!maxQty || isNaN(maxQty)) return;

    var variantId = btn.dataset.id;

    // Check how many already in cart
    var inCart = 0;
    if (cachedCart && cachedCart.items) {
      for (var i = 0; i < cachedCart.items.length; i++) {
        if (String(cachedCart.items[i].variant_id) === String(variantId)) {
          inCart = cachedCart.items[i].quantity;
          break;
        }
      }
    }

    if (inCart >= maxQty) {
      evt.stopImmediatePropagation();
      evt.preventDefault();

      var visibleBtn = btn.querySelector('.btn');
      if (visibleBtn) visibleBtn.classList.remove('btn--loading');

      showLimitError(btn.closest('.grid-product__actions') || btn.parentNode,
        'Maximum of ' + maxQty + ' already in cart.');
    }
  }, true); // capture phase — runs before theme.js QuickAdd handler

})();

/* ============================================
   Cart Upsell: Unified cross-sell section
   Renders manual metafield cross-sells + Shopify AI recs
   in a single section inside [data-ai-recs]
   ============================================ */
(function() {
  var MAX_UPSELLS = 3;
  var cachedAiProducts = null;
  var initialTotal = 0;
  var addedFromUpsell = false;
  var hasRendered = false;

  function formatPrice(cents) {
    var p = cents / 100;
    return '$' + (p % 1 === 0 ? p.toFixed(0) : p.toFixed(2));
  }

  function buildCardHtml(product, isApiProduct) {
    var imgSrc = product.image || product.featured_image || '';
    if (isApiProduct && imgSrc) {
      var sized = imgSrc.replace(/\.(jpg|jpeg|png|gif|webp)/i, '_160x.$1');
      if (sized !== imgSrc) imgSrc = sized;
    }

    var variants = product.variants || [];
    var actionHtml = '';

    if (variants.length > 1) {
      actionHtml = '<div class="cart-upsell__variants">';
      variants.forEach(function(v) {
        var vPrice = isApiProduct ? formatPrice(v.price) : v.price_formatted || formatPrice(v.price);
        actionHtml += '<button type="button" class="cart-upsell__variant-btn" data-id="' + v.id + '">' + v.title + ' - ' + vPrice + '</button>';
      });
      actionHtml += '</div>';
    } else {
      var vid = variants.length ? variants[0].id : '';
      var price = isApiProduct ? formatPrice(product.price) : formatPrice(product.price);
      actionHtml = '<div class="cart-price-upsell">' +
        '<button type="button" class="cart-upsell__variant-btn cart-upsell__variant-btn--single" data-id="' + vid + '">Add to cart</button>' +
        '<div class="price"><span>' + price + '</span></div>' +
      '</div>';
    }

    return '<div class="cart-upsell__item related-item">' +
      '<div class="product-image-upsell">' +
        '<a href="' + product.url + '">' +
          '<img src="' + imgSrc + '" alt="' + (product.title || '') + '" width="80" height="80" loading="lazy">' +
        '</a>' +
      '</div>' +
      '<div class="product-detail-upsell">' +
        '<div class="name"><a href="' + product.url + '">' + product.title + '</a></div>' +
        actionHtml +
      '</div>' +
    '</div>';
  }

  function bindButtons(container) {
    container.querySelectorAll('.cart-upsell__variant-btn').forEach(function(btn) {
      if (btn.dataset.bound) return;
      btn.dataset.bound = 'true';
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        var varId = btn.dataset.id;
        if (!varId) return;
        var origText = btn.textContent;
        btn.style.opacity = '0.5';
        btn.textContent = 'Adding...';

        addedFromUpsell = true;
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ items: [{ id: parseInt(varId), quantity: 1 }] })
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          var card = btn.closest('.cart-upsell__item');
          if (card) {
            card.style.transition = 'opacity 0.3s';
            card.style.opacity = '0';
            setTimeout(function() { card.remove(); }, 300);
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: {} } }));
        })
        .catch(function() {
          btn.style.opacity = '1';
          btn.textContent = origText;
        });
      });
    });
  }

  function renderUpsells() {
    var dataEl = document.querySelector('[data-cart-upsell-data]');
    if (!dataEl) return;

    var aiContainer = document.querySelector('[data-ai-recs]');
    if (!aiContainer) return;

    var data;
    try { data = JSON.parse(dataEl.textContent); } catch(e) { return; }

    var manualProducts = data.manual || [];
    var cartProductIds = (data.cartProductIds || '').split(',').map(function(id) { return id.trim(); });
    var shownIds = (data.shownIds || '').split(',').filter(Boolean);
    var firstProductId = data.firstProductId;
    var hasPlants = data.hasPlants || false;
    var slotsUsed = 0;

    // Inject garden trimmers if cart contains plants and trimmers not already in cart
    var TRIMMERS_ID = '4840408711268';
    var TRIMMERS_PRIORITY_UNTIL = new Date('2026-05-30'); // Priority slot until this date, then falls to end
    var trimmerProduct = null;
    if (hasPlants && cartProductIds.indexOf(TRIMMERS_ID) === -1) {
      trimmerProduct = {
        id: 4840408711268,
        title: 'Herb Cottage Trimmers',
        url: '/products/herbcottage-trimmers',
        image: 'https://cdn.shopify.com/s/files/1/0039/7780/5924/products/trimmers-front-closed_clipped_rev_1_1_160x.jpg?v=1644819014',
        price: 1495,
        variants: [{ id: 32905852813412, title: 'Default Title', price: 1495 }],
        _isInjected: true
      };
      if (new Date() < TRIMMERS_PRIORITY_UNTIL) {
        manualProducts.unshift(trimmerProduct); // Priority: first slot
      } else {
        manualProducts.push(trimmerProduct); // After priority expires: last slot
      }
    }

    // Build manual cards HTML
    var cardsHtml = '';
    manualProducts.forEach(function(product) {
      if (slotsUsed >= MAX_UPSELLS) return;
      if (product.variants) {
        product.variants = product.variants.filter(function(v) { return v && v.id; });
        product.variants.forEach(function(v) { v.price_formatted = formatPrice(v.price); });
      }
      cardsHtml += buildCardHtml(product, false);
      slotsUsed++;
    });

    // If we have cached AI results, re-render them (minus items now in cart)
    if (cachedAiProducts) {
      cachedAiProducts.forEach(function(product) {
        if (slotsUsed >= initialTotal) return;
        if (!product.available) return;
        var pid = String(product.id);
        if (cartProductIds.indexOf(pid) !== -1) return;
        if (shownIds.indexOf(pid) !== -1) return;
        cardsHtml += buildCardHtml(product, true);
        slotsUsed++;
      });

      if (cardsHtml) {
        aiContainer.innerHTML = '<div class="cart-upsell"><div class="cart-upsell__title">You might also like</div>' + cardsHtml + '</div>';
        bindButtons(aiContainer);
      } else {
        aiContainer.innerHTML = '';
      }
      return;
    }

    // First time: fetch AI recs
    var remaining = MAX_UPSELLS - slotsUsed;
    if (remaining <= 0 || !firstProductId) {
      if (cardsHtml) {
        aiContainer.innerHTML = '<div class="cart-upsell"><div class="cart-upsell__title">You might also like</div>' + cardsHtml + '</div>';
        bindButtons(aiContainer);
      }
      initialTotal = slotsUsed;
      cachedAiProducts = [];
      return;
    }

    fetch('/recommendations/products.json?product_id=' + firstProductId + '&limit=8&intent=related')
      .then(function(r) { return r.json(); })
      .then(function(apiData) {
        cachedAiProducts = apiData.products || [];
        cachedAiProducts.forEach(function(product) {
          if (slotsUsed >= MAX_UPSELLS) return;
          if (!product.available) return;
          var pid = String(product.id);
          if (cartProductIds.indexOf(pid) !== -1) return;
          if (shownIds.indexOf(pid) !== -1) return;
          cardsHtml += buildCardHtml(product, true);
          slotsUsed++;
        });

        initialTotal = slotsUsed;

        if (cardsHtml) {
          aiContainer.innerHTML = '<div class="cart-upsell"><div class="cart-upsell__title">You might also like</div>' + cardsHtml + '</div>';
          bindButtons(aiContainer);
        }
      })
      .catch(function() {
        if (cardsHtml) {
          aiContainer.innerHTML = '<div class="cart-upsell"><div class="cart-upsell__title">You might also like</div>' + cardsHtml + '</div>';
          bindButtons(aiContainer);
        }
        initialTotal = slotsUsed;
        cachedAiProducts = [];
      });
  }

  function freshRender() {
    if (addedFromUpsell) {
      addedFromUpsell = false;
      return;
    }
    cachedAiProducts = null;
    initialTotal = 0;
    var aiContainer = document.querySelector('[data-ai-recs]');
    if (aiContainer) aiContainer.innerHTML = '';
    setTimeout(renderUpsells, 50);
  }

  // cart:open fires after buildCart (adding products)
  document.addEventListener('cart:open', freshRender);

  // CartDrawer:open fires when cart icon is clicked (no buildCart)
  document.addEventListener('CartDrawer:open', function() {
    var aiContainer = document.querySelector('[data-ai-recs]');
    if (aiContainer && !aiContainer.innerHTML.trim()) {
      setTimeout(renderUpsells, 50);
    }
  });
})();

/*============================================================================
  Product Notice Confirmation Modal
  - Shows a confirmation dialog when adding products with notices
    (short best-before, batch texture warnings, etc.)
  - Intercepts product page form submit and collection quick-add clicks
  - Uses metafields: custom.short_date_notice, custom.product_notice
  - Custom overlay system (not Expanse theme.Modals) to avoid conflicts
    with the quick-add variant picker modal stacking
==============================================================================*/
(function() {
  'use strict';

  var overlay = null;
  var contentEl = null;
  var confirmBtn = null;
  var cancelBtns = null;
  var pendingAction = null;
  var pendingCleanup = null;
  var isOpen = false;

  function initOverlay() {
    if (overlay) return;
    overlay = document.getElementById('ProductNoticeModal');
    if (!overlay) return;
    contentEl = overlay.querySelector('[data-notice-modal-content]');
    confirmBtn = overlay.querySelector('[data-notice-modal-confirm]');
    cancelBtns = overlay.querySelectorAll('.js-modal-close');

    // Confirm: run the action, then close everything
    if (confirmBtn) {
      confirmBtn.addEventListener('click', function() {
        var action = pendingAction;
        var cleanup = pendingCleanup;
        pendingAction = null;
        pendingCleanup = null;

        // Close our overlay
        closeOverlay();

        // Run cleanup (e.g. close the quick-add modal) synchronously
        if (typeof cleanup === 'function') cleanup();

        // Run the add-to-cart action
        if (typeof action === 'function') action();
      });
    }

    // Cancel / X / close buttons: just close our overlay
    cancelBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        pendingAction = null;
        pendingCleanup = null;
        closeOverlay();
      });
    });

    // Click on backdrop closes
    overlay.addEventListener('click', function(evt) {
      if (evt.target === overlay || evt.target.classList.contains('modal__inner') || evt.target.classList.contains('modal__centered')) {
        pendingAction = null;
        pendingCleanup = null;
        closeOverlay();
      }
    });
  }

  function openOverlay() {
    if (!overlay) return;
    isOpen = true;
    overlay.classList.add('pn-active');
    document.body.classList.add('product-notice-open');
  }

  function closeOverlay() {
    if (!overlay) return;
    isOpen = false;
    overlay.classList.remove('pn-active');
    document.body.classList.remove('product-notice-open');
  }

  function buildNoticeHtml(notices) {
    var html = '';
    if (notices.short_date) {
      html += '<p class="product-notice-modal__item">' + escapeHtml(notices.short_date) + '</p>';
    }
    if (notices.product_notice) {
      html += '<p class="product-notice-modal__item">' + escapeHtml(notices.product_notice) + '</p>';
    }
    return html;
  }

  function buildNoticeHtmlFromText(text) {
    var parts = text.split('|||');
    var html = '';
    for (var i = 0; i < parts.length; i++) {
      var trimmed = parts[i].trim();
      if (trimmed) {
        html += '<p class="product-notice-modal__item">' + escapeHtml(trimmed) + '</p>';
      }
    }
    return html;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  function showNotice(noticeHtml, onConfirm, onCleanup) {
    initOverlay();
    if (!overlay || !contentEl) return false;
    contentEl.innerHTML = noticeHtml;
    pendingAction = onConfirm;
    pendingCleanup = onCleanup || null;
    openOverlay();
    return true;
  }

  // --- Product page: intercept form submit ---
  document.addEventListener('submit', function(evt) {
    var form = evt.target;
    if (!form.classList.contains('product-single__form')) return;

    // Skip if already confirmed
    if (form.__noticeConfirmed) {
      form.__noticeConfirmed = false;
      return;
    }

    // Find notice data in the product section
    var section = form.closest('[data-section-id], .shopify-section, .product-section') || form.parentNode;
    var script = section.querySelector('[data-product-notices]');
    if (!script) return;

    var notices;
    try { notices = JSON.parse(script.textContent); } catch(e) { return; }

    // Only intercept if there are actual notices
    if (!notices.short_date && !notices.product_notice) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    // Remove loading state from button
    var btn = form.querySelector('[data-add-to-cart]');
    if (btn) btn.classList.remove('btn--loading');

    var quickAddModal = form.closest('#QuickAddModal');
    var isQuickAdd = !!quickAddModal;
    var html = buildNoticeHtml(notices);

    // Cleanup function: close the Expanse quick-add modal if present
    var cleanup = isQuickAdd ? function() {
      var closeBtn = quickAddModal.querySelector('.js-modal-close');
      if (closeBtn) closeBtn.click();
    } : null;

    showNotice(html, function() {
      if (isQuickAdd) {
        // Submit directly via AJAX to avoid re-triggering interception
        var formData = new FormData(form);
        var data = {};
        formData.forEach(function(value, key) { data[key] = value; });
        fetch(theme.routes.cartAdd, {
          method: 'POST',
          body: JSON.stringify(data),
          headers: { 'Content-Type': 'application/json' }
        }).then(function(r) { return r.json(); })
          .then(function() {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
          });
      } else {
        // Product page: re-submit with bypass flag
        form.__noticeConfirmed = true;
        var addBtn = form.querySelector('[data-add-to-cart]');
        if (addBtn) {
          addBtn.click();
        } else {
          form.submit();
        }
      }
    }, cleanup);
  }, true); // capture phase — runs before theme.js ProductForm handler

  // --- Collection page: intercept single-variant quick-add ---
  document.addEventListener('click', function(evt) {
    var btn = evt.target.closest('.js-quick-add-btn[data-has-notice]');
    if (!btn) return;

    // Skip if already confirmed (bypass flag)
    if (btn.__noticeConfirmed) {
      btn.__noticeConfirmed = false;
      return;
    }

    var noticeText = btn.getAttribute('data-notice-text');
    if (!noticeText) return;

    evt.preventDefault();
    evt.stopImmediatePropagation();

    // Remove loading state
    var innerBtn = btn.querySelector('.btn');
    if (innerBtn) innerBtn.classList.remove('btn--loading');

    var html = buildNoticeHtmlFromText(noticeText);
    showNotice(html, function() {
      btn.__noticeConfirmed = true;
      btn.click();
    });
  }, true); // capture phase — runs before theme.js QuickAdd and qty limit handlers

})();

/* =============================================
   Footer accordion (mobile only)
   ============================================= */
(function() {
  var triggers = document.querySelectorAll('.footer__title--accordion');
  if (!triggers.length) return;

  function isMobile() {
    return window.innerWidth <= 768;
  }

  triggers.forEach(function(trigger) {
    var content = trigger.nextElementSibling;
    if (!content || !content.classList.contains('footer__accordion-content')) return;

    trigger.addEventListener('click', function() {
      if (!isMobile()) return;

      var isOpen = content.classList.contains('is-open');

      // Close all other accordions
      document.querySelectorAll('.footer__accordion-content.is-open').forEach(function(el) {
        el.classList.remove('is-open');
        el.previousElementSibling.classList.remove('is-active');
        el.previousElementSibling.setAttribute('aria-expanded', 'false');
      });

      // Toggle this one
      if (!isOpen) {
        content.classList.add('is-open');
        trigger.classList.add('is-active');
        trigger.setAttribute('aria-expanded', 'true');
      }
    });

    // Keyboard support
    trigger.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        trigger.click();
      }
    });
  });

  // On desktop, ensure content is always visible
  function handleResize() {
    var contents = document.querySelectorAll('.footer__accordion-content');
    if (!isMobile()) {
      contents.forEach(function(el) {
        el.style.maxHeight = 'none';
      });
    } else {
      contents.forEach(function(el) {
        if (!el.classList.contains('is-open')) {
          el.style.maxHeight = '';
        }
      });
    }
  }

  window.addEventListener('resize', handleResize);
  handleResize();
})();

/* Mobile header: hamburger moved to header.liquid as its own flex item.
   No JS needed - theme.js MobileNav.init() binds to .mobile-nav-trigger automatically. */

/* =============================================
   Seasonal nav badge: highlight current season
   ============================================= */
(function() {
  // Determine current Australian season
  var month = new Date().getMonth(); // 0-11
  var currentSeason;
  if (month >= 2 && month <= 4) currentSeason = 'Autumn';
  else if (month >= 5 && month <= 7) currentSeason = 'Winter';
  else if (month >= 8 && month <= 10) currentSeason = 'Spring';
  else currentSeason = 'Summer';

  var targetText = currentSeason + ' Planting';

  // Find all nav links (desktop + mobile) matching current season
  var links = document.querySelectorAll(
    '.site-nav__dropdown-link, .slide-nav__link, .megamenu a'
  );

  links.forEach(function(link) {
    var span = link.querySelector('span');
    var text = (span ? span.textContent : link.textContent).trim();
    if (text === targetText && !link.querySelector('.nav-season-badge')) {
      var badge = document.createElement('span');
      badge.className = 'nav-season-badge';
      badge.textContent = 'Now';
      if (span) {
        span.appendChild(badge);
      } else {
        link.appendChild(badge);
      }
    }
  });
})();

(function () {
  function rebuildAtcArea() {
    const meta = document.querySelector('.product-single__meta');
    if (!meta) return;
    const quantity = meta.querySelector('.product__quantity');
    const form = meta.querySelector('.product-single__form');
    const atcButton = form && form.querySelector('[data-add-to-cart]');
    if (!quantity || !form || !atcButton) return;
    if (form.querySelector('.atc-bar')) return;
    // Skip the unified bar when sold out — the BIS app injects its own
    // notify-me button and the green bar background looks broken next to it.
    if (atcButton.disabled) return;

    const bar = document.createElement('div');
    bar.className = 'atc-bar';
    atcButton.parentNode.insertBefore(bar, atcButton);
    bar.appendChild(quantity);
    bar.appendChild(atcButton);

    // The qty stepper gets pulled down into the atc-bar above, but the
    // "Limit of N per customer" notice is a sibling of .product__quantity
    // (not inside it), so it stays stranded up by the variant / add-on
    // blocks and reads as if the limit applies to the add-on. Move it under
    // the atc-bar so it sits with the quantity / Add to Cart it governs. [v2]
    const limitNotice = meta.querySelector('[data-qty-limit-notice]');
    if (limitNotice) bar.insertAdjacentElement('afterend', limitNotice);
  }

  // Zooomy heart wire-up removed — our wishlist button is a native button,
  // no proxy clicks required. See hc-wishlist-button.liquid + the HC Wishlist
  // module below for the new flow.

  function moveSalesPointAboveAtc() {
    const meta = document.querySelector('.product-single__meta');
    if (!meta) return;
    const salesPoint = meta.querySelector('.product-block--sales-point');
    const buyButtons = meta.querySelector('.product-block.bss-custom-buy-button');
    if (!salesPoint || !buyButtons) return;
    if (salesPoint.dataset.moved === 'true') return;
    salesPoint.dataset.moved = 'true';
    buyButtons.parentNode.insertBefore(salesPoint, buyButtons);
  }

  function init() {
    rebuildAtcArea();
    moveSalesPointAboveAtc();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  setTimeout(init, 1500);
  setTimeout(init, 3500);
})();

/* ============================================================
   HC Wishlist — Worker-backed wishlist, replaces Zooomy/Wishify.
   ------------------------------------------------------------
   Storage: Cloudflare Worker behind /apps/wishlist/* App Proxy
   (signed by Shopify, customer-keyed). Guests use localStorage
   `hc_wishlist`; on first authenticated request we POST the
   guest items to /apps/wishlist/import to merge them into the
   account, then clear localStorage.

   Heart button: rendered via snippets/hc-wishlist-button.liquid
   on PDPs (inside product-form*.liquid) and product cards
   (inside product-grid-item.liquid). Uses event delegation so
   we don't have to bind per-button as Shopify async-injects
   quick-view modals, recommendation grids, etc.

   Wishlist page: templates/page.zooomywishlist.liquid renders a
   skeleton with `[data-hc-wishlist-root]`. This module fetches
   the customer's items from the Worker, then enriches each
   handle by hitting /products/{handle}.js (parallel) so we
   render fresh title/price/availability rather than snapshots.

   BIS hand-off: sold-out cards link to /products/{handle}?bis=1.
   PDP handler below auto-clicks Stok's notify button and writes
   a localStorage shadow (`hc_bis_shadow`) so the wishlist can
   show "✓ Alert requested". (We've asked Stok for a real read
   API — swap shadow → real reads once they ship it.)
   ============================================================ */
(function () {
  // ---- Config ----
  var API_BASE = '/apps/wishlist';
  var LOCAL_KEY = 'hc_wishlist';
  var SHADOW_KEY = 'hc_bis_shadow';

  // ---- State ----
  var state = {
    items: [],         // [{ product_id, handle, added_at }]
    isLoggedIn: false, // best-effort; flipped to true when GET /apps/wishlist/ returns 200
    booted: false
  };

  // ---- BIS shadow (local-only intent flag, persists across visits) ----
  function readShadow() {
    try { return JSON.parse(localStorage.getItem(SHADOW_KEY) || '{}') || {}; }
    catch (e) { return {}; }
  }
  function writeShadow(map) {
    try { localStorage.setItem(SHADOW_KEY, JSON.stringify(map)); } catch (e) {}
  }
  function setShadowFlag(variantId) {
    if (!variantId) return;
    var m = readShadow();
    m[String(variantId)] = { t: Date.now() };
    writeShadow(m);
  }

  // ---- One-time Zooomy localStorage harvest ----
  // Wishify/Zooomy used the key `myzooomy__wishlist`. We read it once,
  // copy any items into our format, then delete the old key so guest
  // wishlists made before cutover survive their first post-cutover visit.
  function harvestZooomyGuestItems() {
    var raw;
    try { raw = localStorage.getItem('myzooomy__wishlist'); } catch (e) { return []; }
    if (!raw) return [];
    var arr;
    try { arr = JSON.parse(raw); } catch (e) { return []; }
    if (!Array.isArray(arr) || arr.length === 0) {
      try { localStorage.removeItem('myzooomy__wishlist'); } catch (e) {}
      return [];
    }
    var out = [];
    for (var i = 0; i < arr.length; i++) {
      var row = arr[i] || {};
      var pid = parseInt(row.product_id, 10);
      var handle = typeof row.product_handle === 'string' ? row.product_handle.trim() : '';
      if (!pid || !handle) continue;
      out.push({ product_id: pid, handle: handle, added_at: Date.now() });
    }
    try { localStorage.removeItem('myzooomy__wishlist'); } catch (e) {}
    return out;
  }

  // ---- Local items (guest storage + offline cache) ----
  function readLocalItems() {
    try {
      var raw = JSON.parse(localStorage.getItem(LOCAL_KEY) || '[]');
      if (!Array.isArray(raw)) return [];
      return raw
        .map(function (it) {
          if (!it) return null;
          var pid = parseInt(it.product_id, 10);
          var handle = typeof it.handle === 'string' ? it.handle : '';
          if (!pid || !handle) return null;
          return {
            product_id: pid,
            handle: handle,
            added_at: typeof it.added_at === 'number' ? it.added_at : Date.now()
          };
        })
        .filter(Boolean);
    } catch (e) { return []; }
  }
  function writeLocalItems(items) {
    try { localStorage.setItem(LOCAL_KEY, JSON.stringify(items || [])); } catch (e) {}
  }

  // ---- API ----
  function apiList() {
    return fetch(API_BASE + '/', { credentials: 'same-origin' })
      .then(function (r) {
        if (r.status === 401) return { loggedIn: false, items: null };
        if (!r.ok) throw new Error('list_failed:' + r.status);
        return r.json().then(function (data) {
          return { loggedIn: true, items: Array.isArray(data.items) ? data.items : [] };
        });
      });
  }
  function apiToggle(product_id, handle) {
    return fetch(API_BASE + '/toggle', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ product_id: product_id, handle: handle })
    }).then(function (r) {
      if (r.status === 401) return { loggedIn: false };
      if (!r.ok) throw new Error('toggle_failed:' + r.status);
      return r.json().then(function (data) {
        return { loggedIn: true, items: data.items || [], added: !!data.added };
      });
    });
  }
  function apiImport(items) {
    return fetch(API_BASE + '/import', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) {
      if (!r.ok) return null;
      return r.json();
    });
  }

  // ---- UI sync ----
  function isWishlisted(product_id) {
    var pid = parseInt(product_id, 10);
    if (!pid) return false;
    for (var i = 0; i < state.items.length; i++) {
      if (state.items[i].product_id === pid) return true;
    }
    return false;
  }

  function applyStateToButton(btn) {
    var pid = btn.getAttribute('data-product-id');
    var title = btn.getAttribute('data-product-title') || 'this item';
    var active = isWishlisted(pid);
    btn.dataset.hcActive = active ? 'true' : 'false';
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    btn.setAttribute(
      'aria-label',
      (active ? 'Remove ' : 'Add ') + title + (active ? ' from' : ' to') + ' wishlist'
    );
    var dflt = btn.querySelector('[data-hc-label-default]');
    var actv = btn.querySelector('[data-hc-label-active]');
    if (dflt && actv) {
      dflt.hidden = !!active;
      actv.hidden = !active;
    }
  }

  function syncAllButtons() {
    var btns = document.querySelectorAll('[data-hc-wishlist-toggle]');
    for (var i = 0; i < btns.length; i++) applyStateToButton(btns[i]);
    updateHeaderCounter();
  }

  function updateHeaderCounter() {
    // Header bubble lives in snippets/header-icons.liquid as
    // `<span class="wishlist-link__bubble"><span id="zooomy-wishlist-counter"></span></span>`
    // — ID kept for the legacy markup; we drive it ourselves now.
    var el = document.getElementById('zooomy-wishlist-counter');
    if (!el) return;
    var count = state.items.length;
    el.textContent = count > 0 ? String(count) : '';
    var bubble = el.closest('.wishlist-link__bubble');
    if (bubble) {
      // Hide the green dot entirely when wishlist is empty — cleaner than a
      // bubble with no number inside it.
      bubble.style.display = count > 0 ? '' : 'none';
    }
  }

  // ---- Click handler ----
  function handleToggleClick(btn) {
    if (btn.disabled) return;
    var pid = parseInt(btn.getAttribute('data-product-id'), 10);
    var handle = btn.getAttribute('data-handle');
    if (!pid || !handle) return;

    var wasActive = isWishlisted(pid);
    // Optimistic UI: flip immediately
    if (wasActive) {
      state.items = state.items.filter(function (it) { return it.product_id !== pid; });
    } else {
      state.items.push({ product_id: pid, handle: handle, added_at: Date.now() });
    }
    syncAllButtons();

    btn.disabled = true;
    var done = function () { btn.disabled = false; };

    if (state.isLoggedIn) {
      apiToggle(pid, handle).then(function (res) {
        if (!res) return;
        if (res.loggedIn === false) {
          // Session ended mid-session — fall back to local
          state.isLoggedIn = false;
          var local = readLocalItems();
          if (wasActive) {
            local = local.filter(function (it) { return it.product_id !== pid; });
          } else if (!local.some(function (it) { return it.product_id === pid; })) {
            local.push({ product_id: pid, handle: handle, added_at: Date.now() });
          }
          writeLocalItems(local);
          state.items = local;
        } else if (res.items) {
          state.items = res.items;
        }
        syncAllButtons();
        rerenderWishlistGridIfPresent();
      }).catch(function () {
        // Network error — leave optimistic state alone
      }).then(done, done);
    } else {
      var local = readLocalItems();
      if (wasActive) {
        local = local.filter(function (it) { return it.product_id !== pid; });
      } else if (!local.some(function (it) { return it.product_id === pid; })) {
        local.push({ product_id: pid, handle: handle, added_at: Date.now() });
      }
      writeLocalItems(local);
      state.items = local;
      syncAllButtons();
      rerenderWishlistGridIfPresent();
      done();
    }
  }

  // ---- Product data cache ----
  // Every wishlist render hydrates items via /products/{handle}.js. The page
  // renders more than once (saved list arrives, then BIS alerts), and toggles
  // re-render too — so memoise per handle to avoid refetching. It also lets
  // boot() WARM these from the local cache while the App Proxy round trip is
  // still in flight, so the grid pops in instead of waiting on a second burst.
  var productCache = {};
  function fetchProduct(handle) {
    if (!handle) return Promise.resolve(null);
    if (productCache[handle]) return productCache[handle];
    var pr = fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    productCache[handle] = pr;
    return pr;
  }

  // ---- Loading skeleton ----
  var wishlistBootAt = 0;
  // Estimate the card count from the local cache (saved items + remembered BIS
  // alerts) so the skeleton matches the real grid and there's no layout jump.
  function countExpectedItems() {
    var ids = {};
    var items = readLocalItems();
    for (var i = 0; i < items.length; i++) ids[items[i].product_id] = true;
    try {
      var subs = JSON.parse(localStorage.getItem('hc_bis_subs') || '[]');
      if (Array.isArray(subs)) {
        for (var j = 0; j < subs.length; j++) {
          if (subs[j] && subs[j].product_id) ids[subs[j].product_id] = true;
        }
      }
    } catch (e) {}
    return Object.keys(ids).length;
  }
  function renderSkeletons(count) {
    var host = document.querySelector('[data-hc-wishlist-skeleton]');
    if (!host) return;
    if (!count || count < 1) { host.innerHTML = ''; return; }
    var card = '<div class="hc-wsk">' +
      '<div class="hc-wsk__media"></div>' +
      '<div class="hc-wsk__line hc-wsk__line--title"></div>' +
      '<div class="hc-wsk__line hc-wsk__line--price"></div>' +
      '<div class="hc-wsk__line hc-wsk__line--btn"></div>' +
    '</div>';
    var html = '';
    for (var k = 0; k < count; k++) html += card;
    host.innerHTML = html;
  }
  // True once waiting longer won't add items: the BIS server list has loaded
  // or failed (or there's no BIS module). A logged-in customer's list can be
  // mostly migrated Stok alerts that live only in the BIS list until first
  // materialise, so we hold the skeleton rather than flash empty→full. A
  // deadline guarantees we never hang on a stalled server call.
  function bisServerSettled() {
    if (wishlistBootAt && (Date.now() - wishlistBootAt) > 4000) return true;
    if (!(window.hcBis && window.hcBis.serverState)) return true;
    return window.hcBis.serverState() !== 'loading';
  }

  // ---- Wishlist page render ----
  var wishlistPageRendering = false;
  // Re-render requested while one was in flight. Without this, a second
  // render call during the async product fetches was silently DROPPED,
  // which could leave the page half-updated (e.g. the empty state from an
  // early render visible alongside the grid from a later one). Now the
  // request queues and re-runs with the freshest state once the in-flight
  // render finishes — last write wins, every element gets set consistently.
  var wishlistPageQueued = false;

  function finishWishlistRender() {
    wishlistPageRendering = false;
    if (wishlistPageQueued) {
      wishlistPageQueued = false;
      renderWishlistPage();
    }
  }

  function rerenderWishlistGridIfPresent() {
    if (document.querySelector('[data-hc-wishlist-root]')) renderWishlistPage();
  }

  // Hardcoded handles for the starter-products grid shown on the empty state.
  // Chosen from Wishify's top-5 most-wishlisted historic stats to surface
  // products customers have actually shown demand for. Misses fall through
  // silently (the fetch returns null and we filter it out).
  var STARTER_HANDLES = [
    'elderflower-plant',
    'lemon-balm',
    'calendula',
    'echinacea-purpurea'
  ];

  // Read ?ids=h1,h2,h3 from the page URL — used for shared wishlists. A
  // non-empty array overrides the customer's own list for this render only.
  function readSharedHandles() {
    try {
      var qs = new URLSearchParams(window.location.search);
      var raw = qs.get('ids');
      if (!raw) return null;
      var handles = raw.split(',').map(function (h) { return h.trim(); }).filter(Boolean);
      return handles.length > 0 ? handles : null;
    } catch (e) { return null; }
  }

  function renderWishlistPage() {
    if (wishlistPageRendering) { wishlistPageQueued = true; return; }
    var root = document.querySelector('[data-hc-wishlist-root]');
    if (!root) return;
    var grid    = root.querySelector('[data-hc-wishlist-grid]');
    var empty   = root.querySelector('[data-hc-wishlist-empty]');
    var loading = root.querySelector('[data-hc-wishlist-loading]');
    var summary = root.querySelector('[data-hc-wishlist-summary]');
    var actions = root.querySelector('[data-hc-wishlist-actions]');
    if (!grid || !empty || !loading || !summary || !actions) return;

    // ---- Shared wishlist view: ?ids=handle1,handle2,... ----
    // Renders the listed products as a read-only-style view, decoupled from
    // the logged-in customer's own wishlist. Banner at top lets them switch
    // back to their own list.
    var sharedHandles = readSharedHandles();
    if (sharedHandles) {
      renderSharedWishlist(sharedHandles, { root: root, grid: grid, empty: empty, loading: loading, summary: summary, actions: actions });
      return;
    }

    // Hold the skeleton until the BIS server list settles for logged-in
    // customers — their list can be mostly migrated alerts that arrive only
    // from the BIS list, so painting before it lands would flash empty/partial
    // then fill. Guests' subs are already local, so this never holds them.
    // hcbis:loaded (success or failure) re-triggers this render.
    if (state.isLoggedIn && !bisServerSettled()) {
      loading.hidden = false;
      grid.hidden = true;
      empty.hidden = true;
      return;
    }

    // Union: every restock alert is a wishlist item. Materialise alert
    // subscriptions that aren't saved yet (set on another device, or
    // migrated from Stok) so the grid is the one complete watching list.
    // Idempotent: only missing products are added, and the server merge
    // (/import) dedups by product_id anyway.
    if (window.hcBis && window.hcBis.listSubs) {
      var bisSubs = window.hcBis.listSubs();
      var newItems = [];
      for (var bi = 0; bi < bisSubs.length; bi++) {
        var sub = bisSubs[bi];
        if (!sub.product_id || !sub.handle) continue;
        var have = false;
        for (var bj = 0; bj < state.items.length; bj++) {
          if (state.items[bj].product_id === sub.product_id) { have = true; break; }
        }
        for (var bk = 0; bk < newItems.length && !have; bk++) {
          if (newItems[bk].product_id === sub.product_id) have = true;
        }
        if (!have) {
          newItems.push({
            product_id: sub.product_id,
            handle: sub.handle,
            added_at: sub.subscribed_at || Date.now()
          });
        }
      }
      if (newItems.length > 0) {
        state.items = state.items.concat(newItems);
        if (state.isLoggedIn) apiImport(newItems).catch(function () {});
        else writeLocalItems(state.items);
      }
    }

    if (state.items.length === 0) {
      loading.hidden = true;
      grid.hidden = true;
      summary.hidden = true;
      actions.hidden = true;
      empty.hidden = false;
      renderStarterProducts(empty);
      return;
    }

    wishlistPageRendering = true;
    var snapshotItems = state.items.slice();

    Promise.all(snapshotItems.map(function (it) {
      return fetchProduct(it.handle);
    })).then(function (products) {
      var hydrated = snapshotItems
        .map(function (it, i) { return products[i] ? { item: it, product: products[i] } : null; })
        .filter(Boolean);

      // Sort: in-stock first, sold-out last. Within each bucket, preserve
      // insertion order (most-recently-added at the end — matches array order).
      hydrated.sort(function (a, b) {
        if (a.product.available === b.product.available) return 0;
        return a.product.available ? -1 : 1;
      });

      loading.hidden = true;
      empty.hidden = hydrated.length > 0;
      grid.hidden = hydrated.length === 0;

      if (hydrated.length === 0) {
        summary.hidden = true;
        actions.hidden = true;
        renderStarterProducts(empty);
        finishWishlistRender();
        return;
      }

      var total = hydrated.length;
      var inStock = 0;
      var alertsSet = 0;
      for (var i = 0; i < hydrated.length; i++) {
        if (hydrated[i].product.available) inStock++;
        else if (window.hcBis && window.hcBis.hasProduct(hydrated[i].product.id)) alertsSet++;
      }
      var soldOut = total - inStock;
      var parts = [total + ' item' + (total === 1 ? '' : 's')];
      if (inStock > 0) parts.push('<span class="hc-wishlist__summary-available">' + inStock + ' in stock</span>');
      if (soldOut > 0) parts.push('<span class="hc-wishlist__summary-sold-out">' + soldOut + ' sold out</span>');
      if (alertsSet > 0) parts.push('<span class="hc-wishlist__summary-alerts">' + alertsSet + ' alert' + (alertsSet === 1 ? '' : 's') + ' set</span>');
      var summaryHtml = parts.join(' · ');
      // Where restock alerts will be emailed — reassuring for guests (their
      // remembered email) and logged-in customers (their account email).
      var alertEmail = window.hcBis && window.hcBis.getEmail ? window.hcBis.getEmail() : '';
      if (alertsSet > 0 && alertEmail) {
        summaryHtml += '<div class="hc-wishlist__alert-email">Restock alerts go to ' + escapeHtml(alertEmail) + '</div>';
      }
      summary.innerHTML = summaryHtml;
      summary.hidden = false;

      // Build actions: Add all + Share. The handles list is the source of
      // truth for shareable URL since storefront product.js can rehydrate
      // from handles alone.
      var shareHandles = hydrated.map(function (h) { return h.product.handle; });
      var shareUrl = window.location.origin + window.location.pathname + '?ids=' + shareHandles.join(',');
      var actionParts = [];
      if (inStock > 0) {
        actionParts.push('<button type="button" class="hc-wishlist__add-all" data-hc-add-all>Add all available to cart (' + inStock + ')</button>');
      }
      actionParts.push('<button type="button" class="hc-wishlist__share" data-hc-share data-share-url="' + escapeHtml(shareUrl) + '">Share wishlist</button>');
      actions.innerHTML = actionParts.join('');
      actions.hidden = false;

      grid.innerHTML = hydrated.map(buildCardHtml).join('');
      finishWishlistRender();
    }, function () {
      loading.hidden = true;
      grid.hidden = true;
      summary.hidden = true;
      actions.hidden = true;
      empty.hidden = false;
      renderStarterProducts(empty);
      finishWishlistRender();
    });
  }

  // Fetch + render the starter products as small product cards at the bottom
  // of the empty state, so a brand-new visitor has something to heart immediately.
  function renderStarterProducts(emptyEl) {
    if (!emptyEl || emptyEl.dataset.starterRendered === 'true') return;
    emptyEl.dataset.starterRendered = 'true';

    Promise.all(STARTER_HANDLES.map(function (h) {
      return fetchProduct(h);
    })).then(function (products) {
      var valid = products.filter(Boolean);
      if (valid.length === 0) return;

      var starterHtml = '<div class="hc-wishlist__starter">' +
        '<h3 class="hc-wishlist__starter-title">Popular plants to start with</h3>' +
        '<div class="hc-wishlist__starter-grid">' +
          valid.map(function (p) {
            var imgRaw = p.featured_image || (p.images && p.images[0]) || '';
            var imgUrl = imgRaw ? imgRaw.replace(/(\.[a-z]+)(\?|$)/i, '_300x$1$2') : '';
            return '<a href="/products/' + encodeURIComponent(p.handle) + '" class="hc-wishlist__starter-card">' +
              '<img src="' + escapeHtml(imgUrl) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' +
              '<span class="hc-wishlist__starter-name">' + escapeHtml(p.title) + '</span>' +
            '</a>';
          }).join('') +
        '</div>' +
      '</div>';
      emptyEl.insertAdjacentHTML('beforeend', starterHtml);
    });
  }

  // Render a shared-wishlist view (someone else's list, viewed via ?ids=...).
  // Disables the remove buttons + Add-all, replaces with a "Heart these to your
  // wishlist" message and a switch-back link to the viewer's own list.
  function renderSharedWishlist(handles, els) {
    wishlistPageRendering = true;
    els.loading.hidden = false;
    els.empty.hidden = true;
    els.grid.hidden = true;
    els.summary.hidden = true;
    els.actions.hidden = true;

    Promise.all(handles.map(function (h) {
      return fetchProduct(h);
    })).then(function (products) {
      var hydrated = products
        .filter(Boolean)
        .map(function (p) { return { item: { added_at: 0 }, product: p, _shared: true }; });

      // Same sort: in-stock first.
      hydrated.sort(function (a, b) {
        if (a.product.available === b.product.available) return 0;
        return a.product.available ? -1 : 1;
      });

      els.loading.hidden = true;
      if (hydrated.length === 0) {
        els.empty.hidden = false;
        finishWishlistRender();
        return;
      }

      // Banner above the grid
      els.summary.innerHTML =
        '<div class="hc-wishlist__shared-banner">' +
          '<strong>Shared wishlist view</strong> · ' + hydrated.length + ' item' + (hydrated.length === 1 ? '' : 's') +
          ' · <a href="' + window.location.pathname + '">Back to my wishlist</a>' +
        '</div>';
      els.summary.hidden = false;

      els.grid.innerHTML = hydrated.map(buildCardHtml).join('');
      els.grid.hidden = false;
      finishWishlistRender();
    });
  }

  function buildCardHtml(entry) {
    var p = entry.product;
    var isShared = !!entry._shared;
    var firstAvail = null;
    for (var i = 0; i < p.variants.length; i++) {
      if (p.variants[i].available) { firstAvail = p.variants[i]; break; }
    }
    var defaultVariant = firstAvail || p.variants[0] || { id: 0 };
    var isSoldOut = !p.available;

    var imgRaw = p.featured_image || (p.images && p.images[0]) || '';
    var imgUrl = '';
    if (imgRaw) {
      // Insert _400x just before the extension; fall back to original on miss
      var m = imgRaw.match(/^(.+)(\.[a-z]+)(\?.*)?$/i);
      imgUrl = m ? (m[1] + '_400x' + m[2] + (m[3] || '')) : imgRaw;
    }

    // Variant picker: only when the product has more than one variant AND
    // those variants have meaningful titles (i.e. not just the default-only
    // pseudo-variant Shopify gives single-variant products).
    var hasRealVariants = p.variants.length > 1 ||
      (p.variants[0] && p.variants[0].title && p.variants[0].title !== 'Default Title');
    var variantPickerHtml = '';
    if (hasRealVariants && !isSoldOut) {
      variantPickerHtml = '<select class="hc-wcard__variants" data-hc-wcard-variants aria-label="Choose variant">' +
        p.variants.map(function (v) {
          var label = escapeHtml(v.title) + (!v.available ? ' (sold out)' : '');
          return '<option value="' + v.id + '"' + (v.id === defaultVariant.id ? ' selected' : '') + (!v.available ? ' disabled' : '') + '>' + label + '</option>';
        }).join('') +
      '</select>';
    }

    var actionHtml;
    if (!isSoldOut) {
      actionHtml = '<button type="button" class="hc-wcard__buy" data-variant-id="' + defaultVariant.id + '">Add to cart</button>';
    } else if (window.hcBis && window.hcBis.hasProduct(p.id)) {
      // Subscribed for a restock alert. The badge doubles as a cancel
      // control (hover or tap → "Cancel alert"): cancels just the alert and
      // keeps the item saved. "Remove from wishlist" still removes both.
      actionHtml = '<button type="button" class="hc-wcard__alert-set" data-hc-wcard-cancel-alert title="Cancel this restock alert">' +
        '<span class="hc-wcard__alert-on">✓ Alert set</span>' +
        '<span class="hc-wcard__alert-off">Cancel alert</span>' +
        '</button>';
    } else {
      // Direct in-place subscribe (no PDP hop). The HC BIS module handles
      // the click: one tap for known emails, inline email field otherwise.
      actionHtml = '<button type="button" class="hc-wcard__notify" data-hc-card-notify data-variant-id="' + defaultVariant.id + '">Email me when it\'s back</button>';
    }

    // Date added — only on the owner's view, not shared. Format relative
    // ("today", "3 days ago") for the last week, then drop to a calendar
    // date ("12 Apr") which is easier to scan than a long "23 days ago".
    // Returns '' for migrated items (real date unknown), so we skip the div
    // entirely rather than shipping an empty element.
    var dateHtml = '';
    if (!isShared && entry.item && entry.item.added_at) {
      var formatted = formatAddedDate(entry.item.added_at);
      if (formatted) dateHtml = '<div class="hc-wcard__added">' + escapeHtml(formatted) + '</div>';
    }

    // In shared view, remove buttons make no sense — the viewer can't
    // remove items from someone else's wishlist.
    var removeBtnHtml = isShared ? '' :
      '<button type="button" class="hc-wcard__remove" data-hc-wcard-remove aria-label="Remove from wishlist" title="Remove from wishlist">×</button>';
    var removeTextHtml = isShared ? '' :
      '<button type="button" class="hc-wcard__remove-text" data-hc-wcard-remove>Remove from wishlist</button>';

    return '<div class="hc-wcard" data-product-id="' + p.id + '" data-handle="' + escapeHtml(p.handle) + '" data-sold-out="' + (isSoldOut ? 'true' : 'false') + '">' +
      '<a href="/products/' + encodeURIComponent(p.handle) + '" class="hc-wcard__media">' +
        '<img src="' + escapeHtml(imgUrl) + '" alt="' + escapeHtml(p.title) + '" class="hc-wcard__image" loading="lazy">' +
      '</a>' +
      removeBtnHtml +
      '<div class="hc-wcard__body">' +
        '<a href="/products/' + encodeURIComponent(p.handle) + '" class="hc-wcard__title">' + escapeHtml(p.title) + '</a>' +
        '<div class="hc-wcard__price">' + formatMoney(p.price) + '</div>' +
        (isSoldOut ? '<span class="hc-wcard__status">Sold out</span>' : '') +
        dateHtml +
      '</div>' +
      variantPickerHtml +
      '<div class="hc-wcard__action">' + actionHtml + '</div>' +
      removeTextHtml +
    '</div>';
  }

  // Items with an added_at inside this window are leftovers from the
  // Wishify-CSV migration on 2026-05-19 — the script set added_at = now
  // instead of using the CSV's original date column. Hide the date for
  // these so we don't claim "Added today" for items the customer actually
  // wishlisted years ago. Anything timestamped AFTER this cutoff is a
  // genuine post-migration add and renders normally.
  var MIGRATION_BACKFILL_CUTOFF = Date.UTC(2026, 4, 19, 12, 0, 0); // 2026-05-19 12:00 UTC

  // "Added today" / "Added 3 days ago" / "Added 12 Apr". Falls back to a
  // calendar date once the relative form gets unwieldy.
  function formatAddedDate(ts) {
    if (typeof ts !== 'number' || !ts) return '';
    if (ts < MIGRATION_BACKFILL_CUTOFF) return ''; // migrated item, real date unknown
    var now = Date.now();
    var diff = now - ts;
    var day = 24 * 60 * 60 * 1000;
    if (diff < 0) return '';
    if (diff < day) return 'Added today';
    var days = Math.floor(diff / day);
    if (days === 1) return 'Added yesterday';
    if (days <= 6) return 'Added ' + days + ' days ago';
    var d = new Date(ts);
    var months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    var sameYear = d.getFullYear() === new Date().getFullYear();
    return 'Added ' + d.getDate() + ' ' + months[d.getMonth()] + (sameYear ? '' : ' ' + d.getFullYear());
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    var dollars = cents / 100;
    return '$' + (dollars % 1 === 0 ? dollars.toFixed(0) : dollars.toFixed(2));
  }

  // ---- Card actions (delegated, so re-rendering doesn't break listeners) ----
  document.addEventListener('click', function (e) {
    var heart = e.target.closest && e.target.closest('[data-hc-wishlist-toggle]');
    if (heart) {
      e.preventDefault();
      e.stopPropagation();
      handleToggleClick(heart);
      return;
    }
    var removeBtn = e.target.closest && e.target.closest('[data-hc-wcard-remove]');
    if (removeBtn) {
      e.preventDefault();
      e.stopPropagation();
      var card = removeBtn.closest('.hc-wcard');
      if (!card) return;
      var pid = parseInt(card.getAttribute('data-product-id'), 10);
      var handle = card.getAttribute('data-handle');
      if (!pid || !handle) return;
      // One list, one "stop watching" action: removing from the wishlist
      // also cancels any restock alert for the product.
      if (window.hcBis && window.hcBis.cancelProduct) window.hcBis.cancelProduct(pid);
      // Fabricate a toggle on a virtual button so the same flow runs
      var fake = document.createElement('button');
      fake.setAttribute('data-product-id', String(pid));
      fake.setAttribute('data-handle', handle);
      fake.setAttribute('data-product-title', card.querySelector('.hc-wcard__title')?.textContent || '');
      handleToggleClick(fake);
      return;
    }
    var cancelAlertBtn = e.target.closest && e.target.closest('[data-hc-wcard-cancel-alert]');
    if (cancelAlertBtn) {
      e.preventDefault();
      e.stopPropagation();
      var caCard = cancelAlertBtn.closest('.hc-wcard');
      if (!caCard) return;
      var caPid = parseInt(caCard.getAttribute('data-product-id'), 10);
      if (!caPid || !window.hcBis || !window.hcBis.cancelProduct) return;
      cancelAlertBtn.disabled = true;
      cancelAlertBtn.textContent = 'Cancelling...';
      // Cancel just the alert; the item stays saved. The grid re-renders on
      // hcbis:changed, flipping this card back to "Email me when it's back".
      window.hcBis.cancelProduct(caPid).then(function () {
        rerenderWishlistGridIfPresent();
      });
      return;
    }
    var buyBtn = e.target.closest && e.target.closest('.hc-wcard__buy');
    if (buyBtn) {
      e.preventDefault();
      var vid = parseInt(buyBtn.getAttribute('data-variant-id'), 10);
      if (!vid) return;
      buyBtn.disabled = true;
      var orig = buyBtn.textContent;
      buyBtn.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      }).then(function (r) { return r.ok ? r.json() : null; })
        .then(function () {
          buyBtn.textContent = 'Added ✓';
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: {} } }));
          setTimeout(function () { buyBtn.textContent = orig; buyBtn.disabled = false; }, 1400);
        })
        .catch(function () { buyBtn.disabled = false; buyBtn.textContent = orig; });
      return;
    }
    var addAll = e.target.closest && e.target.closest('[data-hc-add-all]');
    if (addAll) {
      e.preventDefault();
      var buyButtons = document.querySelectorAll('.hc-wcard__buy[data-variant-id]');
      var items = [];
      for (var i = 0; i < buyButtons.length; i++) {
        var v = parseInt(buyButtons[i].getAttribute('data-variant-id'), 10);
        if (v) items.push({ id: v, quantity: 1 });
      }
      if (items.length === 0) return;
      addAll.disabled = true;
      addAll.textContent = 'Adding...';
      fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (r) { return r.ok ? r.json() : Promise.reject(); })
        .then(function () { window.location = '/cart'; })
        .catch(function () {
          addAll.disabled = false;
          addAll.textContent = 'Add all available to cart (' + items.length + ')';
        });
    }
    var shareBtn = e.target.closest && e.target.closest('[data-hc-share]');
    if (shareBtn) {
      e.preventDefault();
      var url = shareBtn.getAttribute('data-share-url') || window.location.href;
      copyToClipboard(url).then(function () {
        // Confirm on the button itself — the corner toast alone was easy to
        // miss and read as "share does nothing".
        var orig = shareBtn.textContent;
        shareBtn.textContent = 'Link copied';
        shareBtn.disabled = true;
        setTimeout(function () {
          shareBtn.textContent = orig;
          shareBtn.disabled = false;
        }, 2000);
        showWishlistToast('Wishlist link copied to clipboard');
      }, function () {
        // Clipboard write failed — fall back to a prompt the user can copy from.
        window.prompt('Copy this link to share your wishlist:', url);
      });
    }
  });

  // Variant picker → update the sibling Add to cart button's variant ID.
  // Delegated change handler so it works for cards rendered later too.
  document.addEventListener('change', function (e) {
    var sel = e.target.closest && e.target.closest('[data-hc-wcard-variants]');
    if (!sel) return;
    var card = sel.closest('.hc-wcard');
    if (!card) return;
    var buy = card.querySelector('.hc-wcard__buy');
    if (!buy) return;
    buy.setAttribute('data-variant-id', sel.value);
  });

  function copyToClipboard(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text);
    }
    // Legacy fallback for older browsers
    return new Promise(function (resolve, reject) {
      try {
        var ta = document.createElement('textarea');
        ta.value = text;
        ta.style.position = 'fixed';
        ta.style.opacity = '0';
        document.body.appendChild(ta);
        ta.select();
        var ok = document.execCommand('copy');
        document.body.removeChild(ta);
        ok ? resolve() : reject();
      } catch (err) { reject(err); }
    });
  }

  function showWishlistToast(message) {
    var existing = document.querySelector('.hc-wishlist-toast');
    if (existing) existing.parentNode.removeChild(existing);
    var t = document.createElement('div');
    t.className = 'hc-wishlist-toast';
    t.textContent = message;
    document.body.appendChild(t);
    setTimeout(function () { t.classList.add('is-visible'); }, 10);
    setTimeout(function () {
      t.classList.remove('is-visible');
      setTimeout(function () { t.parentNode && t.parentNode.removeChild(t); }, 250);
    }, 2400);
  }

  // ---- PDP: ?bis=1 auto-open of Stok's notify button -----

  function findBisButton() {
    var selectors = [
      '[class*="bis-"] button',
      '[class*="bis-"] a[href]',
      'button[class*="bis-"]',
      'a[class*="bis-"]',
      'button[class*="notifyme"]',
      'a[class*="notifyme"]',
      'button[class*="notify-me"]',
      'a[class*="notify-me"]',
      'button[class*="back-in-stock"]',
      'a[class*="back-in-stock"]',
      'button[id*="bis"]',
      '.bis-trigger',
      '[data-bis-button]'
    ];
    for (var i = 0; i < selectors.length; i++) {
      var list = document.querySelectorAll(selectors[i]);
      for (var j = 0; j < list.length; j++) {
        var el = list[j];
        var r = el.getBoundingClientRect();
        if (r.width > 0 && r.height > 0) return el;
      }
    }
    return null;
  }
  function getCurrentVariantId() {
    var input = document.querySelector(
      '.product-single__form [name="id"], form[action*="/cart/add"] [name="id"]'
    );
    return input ? input.value : null;
  }
  function stripBisQuery() {
    if (!window.history || !window.history.replaceState) return;
    try {
      var url = new URL(window.location);
      url.searchParams.delete('bis');
      window.history.replaceState({}, '', url.toString());
    } catch (e) {}
  }
  function handleBisQueryOnPdp() {
    if (!/[?&]bis=1\b/.test(window.location.search)) return;
    if (document.body.dataset.hcBisHandled === 'true') return;
    var attempts = 0;
    var maxAttempts = 30;
    function tryOpen() {
      attempts++;
      var target = findBisButton();
      if (target) {
        document.body.dataset.hcBisHandled = 'true';
        var variantId = getCurrentVariantId();
        if (variantId) setShadowFlag(variantId);
        try { target.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
        target.classList.add('hc-bis-highlight');
        setTimeout(function () { target.classList.remove('hc-bis-highlight'); }, 4000);
        setTimeout(function () {
          try { target.click(); } catch (e) {}
        }, 250);
        stripBisQuery();
        return;
      }
      if (attempts < maxAttempts) setTimeout(tryOpen, 200);
    }
    setTimeout(tryOpen, 400);
  }

  // ---- Boot ----
  function boot() {
    if (state.booted) return;
    state.booted = true;

    // Harvest any leftover Zooomy guest wishlist on first post-cutover visit.
    // We dedupe against whatever we already have (e.g. on a return visit
    // someone added something post-cutover before we got a chance to merge).
    var harvested = harvestZooomyGuestItems();
    if (harvested.length > 0) {
      var existing = readLocalItems();
      var byPid = {};
      for (var i = 0; i < existing.length; i++) byPid[existing[i].product_id] = true;
      for (var j = 0; j < harvested.length; j++) {
        if (!byPid[harvested[j].product_id]) {
          existing.push(harvested[j]);
          byPid[harvested[j].product_id] = true;
        }
      }
      writeLocalItems(existing);
    }

    // Seed UI from local cache before the network call so hearts don't flash blank
    state.items = readLocalItems();
    syncAllButtons();

    // Wishlist page only: paint a cache-sized skeleton immediately and warm
    // the per-item product fetches, so the grid appears without the bare-text
    // void or a second sequential fetch burst. No-op on every other page.
    var wlRoot = document.querySelector('[data-hc-wishlist-root]');
    if (wlRoot) {
      wishlistBootAt = Date.now();
      var loggedInHint = wlRoot.getAttribute('data-logged-in') === 'true' ||
        (window.HC_CUSTOMER && window.HC_CUSTOMER.loggedIn === true);
      var expected = countExpectedItems();
      renderSkeletons(expected > 0 ? Math.min(expected, 12) : (loggedInHint ? 4 : 0));
      // Warm product.js for every handle we already know locally (saved items
      // + remembered alerts), overlapping it with the App Proxy round trip.
      var warm = {};
      for (var wi = 0; wi < state.items.length; wi++) warm[state.items[wi].handle] = true;
      try {
        var ws = JSON.parse(localStorage.getItem('hc_bis_subs') || '[]');
        if (Array.isArray(ws)) {
          for (var wj = 0; wj < ws.length; wj++) {
            if (ws[wj] && ws[wj].handle) warm[ws[wj].handle] = true;
          }
        }
      } catch (e) {}
      Object.keys(warm).forEach(function (h) { fetchProduct(h); });
      // Safety net: never let the skeleton hang if a server call stalls.
      setTimeout(function () { rerenderWishlistGridIfPresent(); }, 4500);
    }

    apiList().then(function (res) {
      if (res.loggedIn) {
        state.isLoggedIn = true;
        state.items = res.items || [];

        // Merge local guest items into the account, then clear local
        var local = readLocalItems();
        if (local.length > 0) {
          apiImport(local).then(function () {
            return apiList();
          }).then(function (r2) {
            if (r2 && r2.loggedIn) state.items = r2.items || [];
            writeLocalItems([]);
            syncAllButtons();
            rerenderWishlistGridIfPresent();
          }).catch(function () {
            // Import failed — keep local items, will retry next session
          });
        }
      } else {
        state.isLoggedIn = false;
        state.items = readLocalItems();
      }
      syncAllButtons();
      rerenderWishlistGridIfPresent();
    }).catch(function () {
      // Network failure — local-only mode
      state.isLoggedIn = false;
      state.items = readLocalItems();
      syncAllButtons();
      rerenderWishlistGridIfPresent();
    });

    handleBisQueryOnPdp();
  }

  // Re-render the wishlist grid when BIS state arrives or changes, so
  // sold-out cards flip between "Email me when it's back" and "✓ Alert set"
  // without a reload. (hcBis module lives below in this file.)
  document.addEventListener('hcbis:loaded', rerenderWishlistGridIfPresent);
  document.addEventListener('hcbis:changed', rerenderWishlistGridIfPresent);

  // A new restock alert auto-saves the product to the wishlist. One mental
  // object for customers: the wishlist IS the "things I'm watching" list.
  // (Fires before hcbis:changed, so the re-render above sees the new item.)
  document.addEventListener('hcbis:subscribed', function (e) {
    var d = (e && e.detail) || {};
    var pid = parseInt(d.product_id, 10);
    var handle = typeof d.handle === 'string' ? d.handle : '';
    if (!pid || !handle) return;
    for (var i = 0; i < state.items.length; i++) {
      if (state.items[i].product_id === pid) return;
    }
    state.items.push({ product_id: pid, handle: handle, added_at: Date.now() });
    if (state.isLoggedIn) {
      apiImport([{ product_id: pid, handle: handle }]).catch(function () {});
    } else {
      writeLocalItems(state.items);
    }
    syncAllButtons();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  // Late re-sync for async-injected content (quick-add modals, recs grids)
  setTimeout(syncAllButtons, 1500);
  setTimeout(syncAllButtons, 3500);
})();

/* ============================================================
   HC BIS — back-in-stock alerts (self-hosted, replaces Stok).
   ------------------------------------------------------------
   Backend: the wishlist Worker's /apps/wishlist/bis/* routes
   (subscribe, unsubscribe, list). Detection + sending live in
   the Worker (see herbcottage-wishlist/BACK-IN-STOCK-SPEC.md);
   this module is only the storefront UI:

   - PDP notify block (snippets/hc-bis-button.liquid): visible
     only when the selected variant is sold out. Logged-in =
     one-click subscribe with the account email; guests get an
     inline email field, remembered per browser afterwards.
   - "Already subscribed" state: server truth for logged-in
     customers (cross-device), localStorage mirror for guests.
   - Wishlist page: sold-out cards subscribe in place
     ([data-hc-card-notify], markup built by the wishlist module
     above), and the "Back in stock alerts" section lists every
     active alert with a cancel link.
   ============================================================ */
(function () {
  var API_BASE = '/apps/wishlist';
  var EMAIL_KEY = 'hc_bis_email';
  var SUBS_KEY = 'hc_bis_subs';
  // Shared shop browser: staff sign customers up via the storefront, so the
  // per-browser "remember my email" convenience makes every new customer come
  // up as the previous one. Staff mode (toggle with ?bisstaff=1 / ?bisstaff=0)
  // keeps the browser stateless (blank field every time, no local mirror) and
  // shows an always-on banner so it's obvious the flag is active.
  var STAFF_KEY = 'hc_bis_staff';

  var state = {
    loggedIn: false,
    email: '',          // account email (logged-in) or remembered guest email
    subs: [],           // [{variant_id, product_id, handle, title, variant_title, subscribed_at}]
    serverLoaded: false,
    serverLoading: false,
    staff: false        // staff sign-up mode (see STAFF_KEY)
  };

  // ---- storage ----
  function readStoredSubs() {
    try {
      var parsed = JSON.parse(localStorage.getItem(SUBS_KEY) || '[]');
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) { return []; }
  }
  function writeStoredSubs() {
    if (state.staff) return; // staff mode never persists subs on the shared browser
    try { localStorage.setItem(SUBS_KEY, JSON.stringify(state.subs)); } catch (e) {}
  }
  function rememberEmail(email) {
    if (state.staff) return; // staff mode never remembers a customer's email
    state.email = email;
    try { localStorage.setItem(EMAIL_KEY, email); } catch (e) {}
  }

  // ---- Staff sign-up mode (shared shop browser) ----
  function isStaff() {
    try { return localStorage.getItem(STAFF_KEY) === '1'; } catch (e) { return false; }
  }
  function applyStaffUrlToggle() {
    var v;
    try { v = new URLSearchParams(window.location.search).get('bisstaff'); } catch (e) { return; }
    if (v == null) return;
    try {
      if (v === '1') localStorage.setItem(STAFF_KEY, '1');
      else if (v === '0') localStorage.removeItem(STAFF_KEY);
    } catch (e) {}
  }
  function renderStaffBanner() {
    if (!document.body || document.getElementById('hc-bis-staffbar')) return;
    var bar = document.createElement('div');
    bar.id = 'hc-bis-staffbar';
    bar.className = 'hc-bis-staffbar';
    bar.setAttribute('role', 'status');
    bar.innerHTML =
      '<span class="hc-bis-staffbar__dot" aria-hidden="true"></span>' +
      '<span class="hc-bis-staffbar__text">Staff sign-up mode on. Customer emails are not saved on this device.</span>' +
      '<button type="button" class="hc-bis-staffbar__off" data-hc-bis-staff-off>Turn off</button>';
    document.body.appendChild(bar);
  }

  // ---- helpers ----
  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }
  function validEmail(e) {
    return typeof e === 'string' && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e.trim());
  }
  // Button loading state: swap label to "Saving..." + disable, restore after.
  function setLoading(btn, on, text) {
    if (!btn) return;
    if (on) {
      if (btn.getAttribute('data-label') == null) btn.setAttribute('data-label', btn.textContent);
      btn.textContent = text || 'Saving...';
      btn.disabled = true;
    } else {
      var label = btn.getAttribute('data-label');
      if (label != null) { btn.textContent = label; btn.removeAttribute('data-label'); }
      btn.disabled = false;
    }
  }
  function hasVariant(variantId) {
    for (var i = 0; i < state.subs.length; i++) {
      if (state.subs[i].variant_id === variantId) return true;
    }
    return false;
  }
  function hasProduct(productId) {
    for (var i = 0; i < state.subs.length; i++) {
      if (state.subs[i].product_id === productId) return true;
    }
    return false;
  }
  function dispatch(name, detail) {
    try { document.dispatchEvent(new CustomEvent(name, { detail: detail })); } catch (e) {}
  }

  // ---- API ----
  function apiSubscribe(item, email) {
    return fetch(API_BASE + '/bis/subscribe', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        variant_id: item.variant_id,
        product_id: item.product_id,
        handle: item.handle,
        title: item.title,
        variant_title: item.variant_title,
        email: email
      })
    }).then(function (r) {
      if (!r.ok) throw new Error('subscribe_failed');
      return r.json();
    }).then(function (res) {
      if (state.staff) {
        // Staff sign-up: the Worker has recorded it. Keep this device stateless
        // (no remembered email, no local sub mirror, no wishlist auto-add) so
        // the next customer starts from a blank field.
        return res;
      }
      var lc = email.trim().toLowerCase();
      rememberEmail(lc);
      if (!hasVariant(item.variant_id)) {
        state.subs.push({
          variant_id: item.variant_id,
          product_id: item.product_id,
          handle: item.handle,
          title: item.title,
          variant_title: item.variant_title,
          subscribed_at: Date.now(),
          email: lc // lets a returning guest recover their email if EMAIL_KEY is lost
        });
        writeStoredSubs();
      }
      // subscribed first (the wishlist auto-add listens for it), then
      // changed (triggers re-renders that should see the added item).
      dispatch('hcbis:subscribed', { product_id: item.product_id, handle: item.handle });
      dispatch('hcbis:changed');
      return res;
    });
  }

  // Cancel every alert for a product. Used by the wishlist's remove action
  // (one list, removing = stop watching entirely). Sequential + error-eating:
  // a missed cancel just means one more harmless future email with its own
  // unsubscribe link.
  function cancelProduct(productId) {
    var mine = state.subs.filter(function (s) { return s.product_id === productId; });
    if (mine.length === 0) return Promise.resolve();
    // Remove from local state SYNCHRONOUSLY, before the server calls and
    // before the caller re-renders. Otherwise the wishlist materialiser
    // (which pulls every alert back in as a saved item) sees the still-present
    // sub mid-flight and re-adds the item — which made "Remove from wishlist"
    // appear to drop only the alert and keep the item. Server unsubscribe is
    // best-effort; a missed one just means one more email with its own
    // unsubscribe link, and a logged-in reload reconciles from the server.
    state.subs = state.subs.filter(function (s) { return s.product_id !== productId; });
    writeStoredSubs();
    dispatch('hcbis:changed');
    var chain = Promise.resolve();
    mine.forEach(function (s) {
      chain = chain.then(function () {
        return fetch(API_BASE + '/bis/unsubscribe', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ variant_id: s.variant_id, email: s.email || state.email })
        }).catch(function () {});
      });
    });
    return chain;
  }

  // Server list = source of truth for logged-in customers (cross-device,
  // includes everything migrated from Stok under the same email). Fetched
  // once per page, lazily — only when a BIS surface actually needs it.
  function fetchServerOnce() {
    if (!state.loggedIn || !state.email || state.serverLoaded || state.serverLoading) return;
    state.serverLoading = true;
    fetch(API_BASE + '/bis/list?email=' + encodeURIComponent(state.email), {
      credentials: 'same-origin'
    }).then(function (r) {
      return r.ok ? r.json() : null;
    }).then(function (d) {
      state.serverLoading = false;
      if (d && Array.isArray(d.items)) {
        state.subs = d.items;
        state.serverLoaded = true;
        writeStoredSubs();
        dispatch('hcbis:loaded');
      }
    }).catch(function () {
      state.serverLoading = false; // mirror stays — fine offline
      // Let the wishlist page proceed with whatever it has (local subs) rather
      // than holding its skeleton waiting on a list that will never arrive.
      dispatch('hcbis:loaded');
    });
  }

  // ---- PDP notify block ----
  function renderRoot(root) {
    var variantId = parseInt(root.dataset.variantId, 10);
    var productId = parseInt(root.dataset.productId, 10);
    var cta = root.querySelector('[data-hc-bis-cta]');
    var done = root.querySelector('[data-hc-bis-done]');
    if (!cta || !done) return;
    // Recognise by variant, falling back to product — covers any variant-id
    // drift between how a sub was stored (card vs PDP) on single-variant
    // products, which is nearly all of ours.
    var subscribed = hasVariant(variantId) || hasProduct(productId);
    cta.hidden = subscribed;
    done.hidden = !subscribed;
    if (subscribed) {
      var emailEl = root.querySelector('[data-hc-bis-done-email]');
      if (emailEl) emailEl.textContent = state.email || 'you';
    } else {
      var row = root.querySelector('[data-hc-bis-email-row]');
      var err = root.querySelector('[data-hc-bis-error]');
      if (row) row.hidden = true;
      if (err) err.hidden = true;
    }
  }
  function renderAllRoots() {
    var roots = document.querySelectorAll('[data-hc-bis-root]');
    for (var i = 0; i < roots.length; i++) renderRoot(roots[i]);
  }

  function itemFromRoot(root) {
    var vt = root.dataset.variantTitle || '';
    return {
      variant_id: parseInt(root.dataset.variantId, 10),
      product_id: parseInt(root.dataset.productId, 10),
      handle: root.dataset.handle,
      title: root.dataset.title || root.dataset.handle,
      variant_title: vt && vt !== 'Default Title' ? vt : null
    };
  }

  function showError(root, message) {
    var err = root.querySelector('[data-hc-bis-error]');
    if (!err) return;
    err.textContent = message;
    err.hidden = false;
  }

  // Staff mode confirmation: show a brief note, clear the field, and reset the
  // block to blank so the next customer can be signed up right away.
  function staffSignupDone(root, email) {
    var input = root.querySelector('[data-hc-bis-email]');
    if (input) input.value = '';
    var row = root.querySelector('[data-hc-bis-email-row]');
    if (row) row.hidden = true;
    var done = root.querySelector('[data-hc-bis-done]');
    if (done) done.hidden = true;
    var cta = root.querySelector('[data-hc-bis-cta]');
    if (cta) cta.hidden = false;
    var note = root.querySelector('[data-hc-bis-error]');
    if (note) {
      note.textContent = '✓ Signed up ' + email + '. Ready for the next customer.';
      note.hidden = false;
      note.classList.add('hc-bis__status--ok');
      setTimeout(function () {
        note.hidden = true;
        note.textContent = '';
        note.classList.remove('hc-bis__status--ok');
      }, 6000);
    }
  }

  function subscribeFromRoot(root, email) {
    var item = itemFromRoot(root);
    if (!item.variant_id || !item.handle) return;
    var primary = root.querySelector('[data-hc-bis-subscribe]');
    var go = root.querySelector('[data-hc-bis-go]');
    setLoading(primary, true);
    setLoading(go, true);
    apiSubscribe(item, email).then(function () {
      setLoading(primary, false);
      setLoading(go, false);
      if (state.staff) staffSignupDone(root, email);
      else renderRoot(root); // hides the CTA, shows the "you're on the list" state
    }).catch(function () {
      setLoading(primary, false);
      setLoading(go, false);
      showError(root, 'Something went wrong. Please try again.');
    });
  }

  // Keep the main PDP block in sync with variant switches. The theme
  // toggles [data-add-to-cart]'s disabled attribute on every variant
  // change, so observing it covers availability; the variant id is
  // re-read from the form at that moment.
  function initPdpSync() {
    var root = document.querySelector('[data-hc-bis-root]');
    if (!root) return;
    var meta = root.closest('.product-single__meta') || document;
    var atc = meta.querySelector('[data-add-to-cart]');

    function currentVariant() {
      var input = meta.querySelector('form [name="id"]');
      var vid = input ? parseInt(input.value, 10) : 0;
      var list = [];
      var ta = meta.querySelector('[data-variant-json]');
      if (ta) { try { list = JSON.parse(ta.textContent); } catch (e) {} }
      for (var i = 0; i < list.length; i++) {
        if (list[i].id === vid) return list[i];
      }
      return list.length === 1 ? list[0] : null;
    }

    function refresh() {
      var v = currentVariant();
      if (v) {
        root.dataset.variantId = String(v.id);
        root.dataset.variantTitle = v.title || '';
      }
      var soldOut = atc ? atc.disabled : (v ? !v.available : false);
      root.hidden = !soldOut;
      if (soldOut) {
        fetchServerOnce(); // lazy server check the first time the block shows
        renderRoot(root);
      }
    }

    if (atc) {
      new MutationObserver(refresh).observe(atc, { attributes: true, attributeFilter: ['disabled'] });
    }
    meta.addEventListener('change', function () { setTimeout(refresh, 50); });
    refresh();
  }

  // (No separate "alerts" section: alerts ARE wishlist items. The wishlist
  // module unions BIS subscriptions into its grid via window.hcBis.listSubs
  // and shows the alert state on each sold-out card.)

  // ---- Wishlist card in-place subscribe (markup built by the wishlist
  // module above; we own the behaviour) ----
  function cardEmailPrompt(container, item) {
    container._hcBisItem = item;
    container.innerHTML =
      '<div class="hc-bis__email-row">' +
        '<input type="email" class="hc-bis__email" data-hc-card-email placeholder="Your email address" autocomplete="email" aria-label="Email address for the restock alert">' +
        '<button type="button" class="hc-bis__go" data-hc-card-go>Go</button>' +
      '</div>';
    var input = container.querySelector('input');
    if (input) input.focus();
  }
  function cardMarkDone(container) {
    container.innerHTML = '<span class="hc-wcard__alert-set">✓ Alert set</span>';
  }

  // ---- Delegated events ----
  document.addEventListener('click', function (e) {
    // Staff mode: turn off → drop the flag and reload into normal mode.
    var staffOff = e.target.closest && e.target.closest('[data-hc-bis-staff-off]');
    if (staffOff) {
      try { localStorage.removeItem(STAFF_KEY); } catch (e2) {}
      var bar = document.getElementById('hc-bis-staffbar');
      if (bar && bar.parentNode) bar.parentNode.removeChild(bar);
      try {
        var u = new URL(window.location.href);
        u.searchParams.delete('bisstaff');
        window.location.replace(u.toString());
      } catch (e3) { window.location.reload(); }
      return;
    }
    // PDP: main subscribe button
    var subBtn = e.target.closest && e.target.closest('[data-hc-bis-subscribe]');
    if (subBtn) {
      var root = subBtn.closest('[data-hc-bis-root]');
      if (!root) return;
      if (state.email) {
        subscribeFromRoot(root, state.email);
      } else {
        var row = root.querySelector('[data-hc-bis-email-row]');
        if (row) {
          row.hidden = false;
          var input = row.querySelector('[data-hc-bis-email]');
          if (input) input.focus();
        }
      }
      return;
    }
    // PDP: guest email submit
    var goBtn = e.target.closest && e.target.closest('[data-hc-bis-go]');
    if (goBtn) {
      var goRoot = goBtn.closest('[data-hc-bis-root]');
      var emailInput = goRoot && goRoot.querySelector('[data-hc-bis-email]');
      var email = emailInput ? emailInput.value : '';
      if (!validEmail(email)) {
        if (goRoot) showError(goRoot, 'Please enter a valid email address.');
        return;
      }
      subscribeFromRoot(goRoot, email.trim());
      return;
    }
    // PDP: cancel alert. Cancel by product (matches renderRoot's recognise-
    // by-product), so it clears the alert even if the stored variant id
    // differs from the one currently selected on the page.
    var cancelBtn = e.target.closest && e.target.closest('[data-hc-bis-cancel]');
    if (cancelBtn) {
      var cRoot = cancelBtn.closest('[data-hc-bis-root]');
      if (!cRoot) return;
      setLoading(cancelBtn, true, 'Cancelling...');
      cancelProduct(parseInt(cRoot.dataset.productId, 10)).then(function () {
        setLoading(cancelBtn, false);
        renderRoot(cRoot);
      });
      return;
    }
    // Wishlist card: notify button
    var cardBtn = e.target.closest && e.target.closest('[data-hc-card-notify]');
    if (cardBtn) {
      e.preventDefault();
      var card = cardBtn.closest('.hc-wcard');
      if (!card) return;
      var titleEl = card.querySelector('.hc-wcard__title');
      var item = {
        variant_id: parseInt(cardBtn.getAttribute('data-variant-id'), 10),
        product_id: parseInt(card.getAttribute('data-product-id'), 10),
        handle: card.getAttribute('data-handle'),
        title: titleEl ? titleEl.textContent.trim() : card.getAttribute('data-handle'),
        variant_title: null
      };
      var container = cardBtn.parentNode;
      if (state.email) {
        setLoading(cardBtn, true);
        apiSubscribe(item, state.email).then(function () {
          cardMarkDone(container);
        }).catch(function () {
          setLoading(cardBtn, false);
          cardBtn.textContent = 'Try again';
        });
      } else {
        cardEmailPrompt(container, item);
      }
      return;
    }
    // Wishlist card: guest email submit
    var cardGo = e.target.closest && e.target.closest('[data-hc-card-go]');
    if (cardGo) {
      var holder = cardGo.closest('.hc-wcard__action');
      var cItem = holder && holder._hcBisItem;
      var cInput = holder && holder.querySelector('[data-hc-card-email]');
      var cEmail = cInput ? cInput.value : '';
      if (!cItem || !validEmail(cEmail)) {
        if (cInput) cInput.style.borderColor = '#d54d4d';
        return;
      }
      setLoading(cardGo, true);
      apiSubscribe(cItem, cEmail.trim()).then(function () {
        cardMarkDone(holder);
      }).catch(function () {
        setLoading(cardGo, false);
        if (cInput) cInput.style.borderColor = '#d54d4d';
      });
      return;
    }
  });

  // Enter key in either email field submits
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter') return;
    var t = e.target;
    if (t && t.matches && t.matches('[data-hc-bis-email]')) {
      e.preventDefault();
      var go = t.closest('[data-hc-bis-email-row]');
      var btn = go && go.querySelector('[data-hc-bis-go]');
      if (btn) btn.click();
    } else if (t && t.matches && t.matches('[data-hc-card-email]')) {
      e.preventDefault();
      var holder = t.closest('.hc-bis__email-row');
      var cardBtn = holder && holder.querySelector('[data-hc-card-go]');
      if (cardBtn) cardBtn.click();
    }
  });

  // ---- Boot ----
  function boot() {
    // Staff sign-up mode is global: process the ?bisstaff= toggle and show the
    // always-on banner on EVERY page, before the early-return below, so the
    // activation link works from anywhere and the banner reminds staff it's on.
    applyStaffUrlToggle();
    state.staff = isStaff();
    if (state.staff) renderStaffBanner();

    // BIS surfaces: the PDP notify block, or the wishlist page (whose grid
    // unions BIS subscriptions in). Both carry the customer email + login
    // state as data attributes.
    var cfg = document.querySelector('[data-hc-bis-root], [data-hc-wishlist-root]');
    if (!cfg) return; // no BIS surface on this page
    // window.HC_CUSTOMER (set in layout/theme.liquid, template scope) is the
    // authoritative source for the signed-in customer — the data attributes
    // are a fallback, since a {% render %}'d PDP snippet can emit them empty.
    var globalCust = window.HC_CUSTOMER || {};
    state.loggedIn = cfg.getAttribute('data-logged-in') === 'true' || globalCust.loggedIn === true;
    var accountEmail = (cfg.getAttribute('data-customer-email') || globalCust.email || '').trim().toLowerCase();
    var storedEmail = '';
    try { storedEmail = (localStorage.getItem(EMAIL_KEY) || '').trim().toLowerCase(); } catch (e) {}
    // Staff mode keeps the browser stateless: no remembered/account email and
    // no local sub mirror, so every customer starts from a blank field and no
    // product shows a previous customer's "already subscribed" state.
    state.email = state.staff ? '' : (state.loggedIn && accountEmail ? accountEmail : storedEmail);
    state.subs = state.staff ? [] : readStoredSubs();
    // Recover a guest's email from a stored sub if EMAIL_KEY was lost (e.g.
    // subs persisted by an earlier build). Lets a returning guest one-click
    // and see "you're on the list" with their address, instead of re-typing.
    if (!state.staff && !state.email) {
      for (var si = 0; si < state.subs.length; si++) {
        if (state.subs[si].email) { rememberEmail(state.subs[si].email); break; }
      }
    }

    renderAllRoots();
    initPdpSync();

    // The wishlist page needs the full server list up front (its grid
    // unions alerts in); PDP blocks fetch lazily when they first become
    // visible (see initPdpSync).
    if (document.querySelector('[data-hc-wishlist-root]')) fetchServerOnce();
  }

  document.addEventListener('hcbis:loaded', function () {
    renderAllRoots();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Clear-x button in the header search fields (2026-07-11). Visibility is
  // pure CSS (:placeholder-shown); this just wipes the text, refocuses, and
  // fires the events the predictive module listens on so it resets to the
  // top-searched suggestions. Delegated so it covers every search form.
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('.site-header__search-btn--clear');
    if (!btn) return;
    e.preventDefault();
    var form = btn.closest('.site-header__search-form');
    var input = form && form.querySelector('.site-header__search-input');
    if (!input) return;
    input.value = '';
    input.focus();
    // Empty keyup runs the theme's reset(): clears the results + currentString
    // so a fresh search works. We then force the whole panel closed — pressing
    // X should DISMISS the dropdown, not leave Top Searched showing. Focus
    // stays so the customer can type a new query straight away.
    input.dispatchEvent(new Event('input', { bubbles: true }));
    input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true, key: 'Backspace' }));
    var wrap = document.getElementById('SearchResultsWrapper');
    var predictive = document.getElementById('PredictiveWrapper');
    if (predictive) predictive.classList.add('hide');
    if (wrap) wrap.classList.add('hide');
  });

  // Surface for the wishlist module: card state, the grid union, the email
  // address alerts go to, and the remove/cancel action.
  window.hcBis = {
    hasProduct: hasProduct,
    hasVariant: hasVariant,
    getEmail: function () { return state.email; },
    listSubs: function () { return state.subs.slice(); },
    cancelProduct: cancelProduct,
    // 'loading' while the logged-in server list is in flight, else 'done'.
    // The wishlist page uses this to hold its skeleton until alerts arrive.
    serverState: function () { return state.serverLoading ? 'loading' : 'done'; }
  };
})();

/*============================================================================
  Calendar + plants cart note (2026-10-08)
  - Shows snippets/hc-calendar-note.liquid when the cart holds a moon
    calendar (SKU cal20xx, any edition) AND a live plant (product type
    starting "Plants", or "Fruit Tree"): the calendar ships separately by
    regular post because plants only go out on Mondays and Tuesdays.
  - Re-checked from /cart.js on every cart change: the drawer's items are
    rendered by theme JS, so the Liquid first state goes stale.
  - Also drives snippets/hc-plant-note.liquid (2026-10-23): "plants are sent
    on Mondays and Tuesdays only" for any cart with a plant, hidden when the
    calendar note is showing because that note already says it.
==============================================================================*/
(function() {
  'use strict';

  var CALENDAR_SKU = /^cal20\d{2}/;

  function isPlant(item) {
    var type = item.product_type || '';
    return type.indexOf('Plants') === 0 || type === 'Fruit Tree';
  }

  function render(cart) {
    var items = (cart && cart.items) || [];
    var hasCal = items.some(function(i) { return CALENDAR_SKU.test(i.sku || ''); });
    var hasPlant = items.some(isPlant);
    var show = hasCal && hasPlant;
    document.querySelectorAll('[data-hc-calendar-note]').forEach(function(el) {
      el.classList.toggle('hide', !show);
    });
    // Plant dispatch-day note (snippets/hc-plant-note.liquid, 2026-10-23):
    // any plant in the cart, unless the calendar note above already says it.
    document.querySelectorAll('[data-hc-plant-note]').forEach(function(el) {
      el.classList.toggle('hide', !(hasPlant && !hasCal));
    });
  }

  function refresh() {
    fetch('/cart.js?t=' + Date.now(), { credentials: 'same-origin' })
      .then(function(r) { return r.json(); })
      .then(render)
      .catch(function() {});
  }

  document.addEventListener('cart:updated', function(evt) {
    if (evt.detail && evt.detail.cart) render(evt.detail.cart);
    else refresh();
  });
  document.addEventListener('ajaxProduct:added', refresh);
  document.addEventListener('cart:open', refresh);
  document.addEventListener('CartDrawer:open', refresh);
})();

